export default "__VITE_ASSET__CMX9lLHy__"